export default "__VITE_ASSET__C_1L9gOP__"